export const isTagsExistId = (tags, id) => {
    const ids = tags.map(tag => tag.id)
    return ids.includes(id)
}
